import React  from 'react';

import ruzhizhiyinshouce from '../assets/img/ruzhizhiyinshouce.png';

const Enclosure37 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div>
            <img src={ruzhizhiyinshouce} alt="" style={{
                width  : '80%',
                display: 'block',
                margin : '0 auto'
            }}/>
            
            <br/><br/>
        </div>
    </div>



export default Enclosure37;